import {
  createSlice,
  createAsyncThunk,
  createSelector } from
'@reduxjs/toolkit';
import { ApolloClient, gql, NormalizedCacheObject } from '@apollo/client';
import { RootState } from '@src/redux/store';
import * as TYPES from '@src/redux/types';

const GRAPHQL = gql`
  mutation createSystemUiModule($data: createSystemUiModuleInput!) {
    createSystemUiModule(data: $data) {
      id
      status
      error {
        message
        statusCode
      }
    }
  }
`;

const initialState: TYPES.MutationResponseState = {
  result: null,
  error: null,
  loading: false
};

export const createSystemUiModuleRequest = createAsyncThunk<
  TYPES.MutationResponse,
  {data: TYPES.CreateSystemUiModuleInput;},
  {extra: ApolloClient<NormalizedCacheObject>;}>(

  'system_ui_module/create_system_ui_module',
  async (
  params: {data: TYPES.CreateSystemUiModuleInput;},
  { extra: client }) =>
  {
    try {
      const response = await client.mutate({
        mutation: GRAPHQL,
        variables: params
      });
      return response.data.createSystemUiModule;
    } catch (error) {
      const err = error as {message?: String;statusCode?: String;};
      return Promise.reject({
        message: err.message || 'An error occurred',
        statusCode: err.statusCode || '500'
      });
    }
  }
);

const createSystemUiModuleSlice = createSlice({
  name: 'create_system_ui_module',
  initialState: initialState,
  reducers: {
    createSystemUiModuleClear: (state) => {
      state.result = null;
      state.error = null;
      state.loading = false;
    }
  },
  extraReducers: (builder) => {
    builder.
    addCase(createSystemUiModuleRequest.pending, (state) => {
      state.result = null;
      state.error = null;
      state.loading = true;
    }).
    addCase(createSystemUiModuleRequest.fulfilled, (state, action) => {
      state.result = action.payload;
      state.loading = false;
    }).
    addCase(createSystemUiModuleRequest.rejected, (state, action) => {
      state.error = action.payload as Error || {
        message: 'Failed to fetch',
        statusCode: '500'
      };
      state.loading = false;
    });
  }
});

export const { createSystemUiModuleClear } =
createSystemUiModuleSlice.actions;

export const createSystemUiModule = createSelector(
  (state: RootState) => state.systemUiModule.createSystemUiModule.result,
  (state: RootState) => state.systemUiModule.createSystemUiModule.error,
  (state: RootState) => state.systemUiModule.createSystemUiModule.loading,
  (result, error, loading) => ({
    result,
    error,
    loading
  })
);

export default createSystemUiModuleSlice.reducer;